import { initializerDefineProperty as _initializerDefineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { assertThisInitialized as _assertThisInitialized } from "\0rollupPluginModLoBabelHelpers.js";
import { inheritsLoose as _inheritsLoose } from "\0rollupPluginModLoBabelHelpers.js";
import { defineProperty as _defineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { applyDecoratedDescriptor as _applyDecoratedDescriptor } from "\0rollupPluginModLoBabelHelpers.js";
import { initializerWarningHelper as _initializerWarningHelper } from "\0rollupPluginModLoBabelHelpers.js";

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _temp;

import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "6897aX7eDtNfYRM7VWpsDGt", "GameScene", undefined);

// Learn TypeScript:
//  - https://docs.cocos.com/creator/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
// import { _decorator, Component, Node, isValid, Prefab, UITransform } from 'cc';
// import { E_EventType, E_MainLayerType } from './common/EnumBase';
// import { App } from './common/manager/App';
// const { ccclass, property } = _decorator;
// @ccclass('Main')
//  - https://docs.cocos.com/creator/manual/en/scripting/life-cycle-callbacks.html
import { _decorator, Component, Vec3, Line, Node, v3, PhysicsSystem, RigidBody, instantiate, v2, misc, MeshCollider, utils, Material, MeshRenderer, renderer, math, ParticleSystem, tween, Texture2D, gfx } from "cc";
import { E_EventType, E_GameState, E_ResPath } from "./common/EnumBase";
import { App } from "./common/manager/App";
var ccclass = _decorator.ccclass,
    property = _decorator.property;
var GameScene = (_dec = property(Line), _dec2 = property(Node), _dec3 = property(Node), _dec4 = property(Node), _dec5 = property(Node), _dec6 = property(Node), _dec7 = property(Node), _dec8 = property(Node), _dec9 = property(Node), _dec10 = property(Material), _dec11 = property(Material), _dec12 = property(Texture2D), _dec13 = property(Material), ccclass(_class = (_class2 = (_temp = /*#__PURE__*/function (_Component) {
  _inheritsLoose(GameScene, _Component);

  function GameScene() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _initializerDefineProperty(_assertThisInitialized(_this), "a_line_game", _descriptor, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "a_n_ball", _descriptor2, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "a_n_cubePhy", _descriptor3, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "a_n_meshPhy", _descriptor4, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "a_n_simplexPhy", _descriptor5, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "a_n_map", _descriptor6, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "n_winTip", _descriptor7, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "n_testShow", _descriptor8, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "ps_ballDie", _descriptor9, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "mat_new", _descriptor10, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "mat_line", _descriptor11, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "tex_tepm", _descriptor12, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "mat_ballPSDie", _descriptor13, _assertThisInitialized(_this));

    _defineProperty(_assertThisInitialized(_this), "_p_winTip", null);

    _defineProperty(_assertThisInitialized(_this), "_h_winTip", 0);

    return _this;
  }

  var _proto = GameScene.prototype;

  _proto.onLoad = function onLoad() {
    PhysicsSystem.instance.enable = false;
    PhysicsSystem.instance.fixedTimeStep = 1 / 60;
    PhysicsSystem.instance.resetAccumulator(0);
    App.GameCtrl.ball_game = this.a_n_ball;
    App.MapCtr.n_map = this.a_n_map;
    App.GameCtrl.n_winTip = this.n_winTip;
    App.GameCtrl.line_game = this.a_line_game.node;
    this.init();
    var m_winTip = this.n_winTip.getComponent(MeshRenderer).materials[0];
    this._p_winTip = m_winTip.passes[0];
    this._h_winTip = this._p_winTip.getHandle("tilingOffset");
  };

  _proto.start = function start() {
    this.addEventListenr();
    this.updateWinTip();
    this.updateBall(App.DataMgr.ballCur);
    var matInfo = {
      parent: null,
      owner: null,
      subModelIdx: 0
    }; //@ts-ignore

    matInfo.parent = this.mat_line;
    matInfo.subModelIdx = 0; //@ts-ignore

    this.a_line_game["_materialInstance"] = new renderer.MaterialInstance(matInfo); //@ts-ignore

    this.a_line_game["_materialInstance"].recompileShaders({
      CC_USE_WORLD_SPACE: false
    }); //@ts-ignore

    var lineModel = this.a_line_game["_model"].updateMaterial(this.a_line_game["_materialInstance"]); //@ts-ignore

    this.a_line_game["_materialInstance"].setProperty('mainTexture', this.tex_tepm); // //@ts-ignore
    // this.a_line_game["_materialInstance"].setProperty('mainTiling_Offset', new Vec4(1, 1, 0, 0));
    // //@ts-ignore
    // this.a_line_game["_model"].setSubModelMaterial(0, this.a_line_game["_materialInstance"]);
  };

  _proto.init = function init() {
    var _this2 = this;

    var ballTex = App.DataMgr.initBallTex();
    App.ResMgr.getTex(E_ResPath.Tex_BallRoot + ballTex.get(App.DataMgr.ballCur), function (tex) {
      var mat = _this2.a_n_ball.getChildByName("n_ball").getComponent(MeshRenderer).materials[0];

      mat.setProperty("mainTexture", tex);
    });
  };

  _proto.onDestroy = function onDestroy() {
    this.removeEventListener();
  };

  _proto.addEventListenr = function addEventListenr() {
    App.EventMgr.addEventLintener(E_EventType.Line_Reset, this.handle_lineReset, this);
    App.EventMgr.addEventLintener(E_EventType.Ball_Die, this.handle_ballDie, this); //球 - 皮肤更换

    App.EventMgr.addEventLintener(E_EventType.Ball_Change, this.updateBall, this);
  };

  _proto.removeEventListener = function removeEventListener() {
    App.EventMgr.removeEvent(this);
  };

  _proto.enter = function enter() {}
  /**游戏开始 */
  ;

  _proto.handle_gameBegin = function handle_gameBegin() {}
  /**重置线 */
  ;

  _proto.handle_lineReset = function handle_lineReset() {
    App.GameCtrl.pos_game = [];
    this.a_line_game.node.destroyAllChildren();
    this.a_line_game.positions = [];
  }
  /**小球死亡 */
  ;

  _proto.handle_ballDie = function handle_ballDie() {
    var _this3 = this;

    var ps = this.ps_ballDie.getComponent(ParticleSystem);
    ps.clear();
    var ball = App.GameCtrl.ball_game;
    var v_ball = App.GameCtrl.v_ballPre;
    this.ps_ballDie.active = true;
    this.ps_ballDie.setWorldPosition(ball.worldPosition.add(v3(0, 0, 2)));
    var xMin = 3;
    var xMax = 6;

    if (v_ball.x < 0) {
      xMin = -6;
      xMax = -3;
    }

    ps.velocityOvertimeModule.enable = false;
    ps.velocityOvertimeModule.x.constantMin = xMin;
    ps.velocityOvertimeModule.x.constantMax = xMax;
    ps.velocityOvertimeModule.enable = true;
    ps.play();
    tween(this.ps_ballDie).delay(1.5).call(function () {
      _this3.ps_ballDie.active = false;
    }).start();
  };

  _proto.updateBall = function updateBall(ballId) {
    var _this4 = this;

    var ballTex = App.DataMgr.initBallTex();
    App.ResMgr.getTex(E_ResPath.Tex_BallRoot + ballTex.get(ballId), function (tex) {
      var ps = _this4.ps_ballDie.getComponent(ParticleSystem);

      var m_psDie = new Material();
      m_psDie.copy(_this4.mat_ballPSDie);
      m_psDie.setProperty("mainTexture", tex);
      ps.renderer.particleMaterial = m_psDie;
      ps.clear();
      ps.stop();
    });
  };

  _proto.update = function update(dt) {
    if (App.GameCtrl.gameState == E_GameState.Over) {
      if (this.a_line_game.positions.length != 0) {
        this.a_line_game.positions = [];
        this.a_line_game.node.destroyAllChildren();
      }
    }

    if (App.GameCtrl.gameState != E_GameState.Gaming) return; // this.updateLine_mesh();

    App.MapCtr.generateItem();
    this.updateWinTip();
  };

  _proto.lateUpdate = function lateUpdate(dt) {
    if (App.GameCtrl.gameState != E_GameState.Gaming) return;
    this.updateLine_mesh();
  };

  _proto.updateLine = function updateLine() {
    if (!App.GameCtrl.isLineDirty) return;
    App.GameCtrl.isLineDirty = false;
    var pos_cur = App.GameCtrl.pos_game;
    if (pos_cur.length < 2) return;
    this.node.getComponent(RigidBody); //设置line points

    this.a_line_game.positions = pos_cur; //@ts-ignore

    var subMeshData = this.a_line_game["_model"]["_subMeshData"];

    if (subMeshData) {
      var meshInfo = subMeshData.geometricInfo;
    } //更新节点数据


    App.GameCtrl.isLineAngleZero = true;
    var children = this.a_line_game.node.children;
    var i = 1;

    for (; i < pos_cur.length; i++) {
      if (pos_cur[i].x == pos_cur[i - 1].x && pos_cur[i].y == pos_cur[i - 1].y) continue;
      var c_cur = children[i - 1];
      var isOwn = true;

      if (!c_cur) {
        isOwn = false;
        c_cur = instantiate(this.a_n_cubePhy);
        c_cur.parent = this.a_line_game.node;
        c_cur.active = true;
      } //中心点坐标


      var posAdd = v3();
      Vec3.add(posAdd, pos_cur[i - 1], pos_cur[i]);
      posAdd.multiplyScalar(0.5);
      var posSub = v3();
      Vec3.subtract(posSub, pos_cur[i], pos_cur[i - 1]);
      c_cur.setPosition(v3(posAdd.x, posAdd.y, 0));
      var len = posSub.length();
      c_cur.scale = v3(len, 0.05, 0.05); //旋转角度

      var radian = -v2(posSub.x, posSub.y).signAngle(v2(1, 0));
      var angle = misc.radiansToDegrees(radian);
      c_cur.angle = angle;

      if (angle != 0) {
        App.GameCtrl.isLineAngleZero = false;
      }
    }

    for (; i < children.length; i++) {
      children[i].destroy();
    }
  };

  _proto.updateLine_simplex = function updateLine_simplex() {
    if (!App.GameCtrl.isLineDirty) return;
    App.GameCtrl.isLineDirty = false;
    var pos_cur = App.GameCtrl.pos_game;
    if (pos_cur.length < 2) return; //设置line points

    this.a_line_game.positions = pos_cur; //更新节点数据

    App.GameCtrl.isLineAngleZero = false;
    var children = this.a_line_game.node.children;
    var i = 1;
    var isAllZero = true;

    for (; i < pos_cur.length; i++) {
      if (pos_cur[i].x == pos_cur[i - 1].x && pos_cur[i].y == pos_cur[i - 1].y) continue;
      var c_cur = children[i - 1];
      var isOwn = true;
      var com_simplex = null;

      if (!c_cur) {
        isOwn = false; // let n_simplex: Node = new Node();
        // n_simplex.parent = this.a_line_game.node;
        // let body: RigidBody = n_simplex.addComponent(RigidBody);
        // body.group = ColliderGroup.LINE;
        // body.type = physics.ERigidBodyType.STATIC;
        // com_simplex = n_simplex.addComponent(SimplexCollider)!;
        // com_simplex.shapeType = physics.ESimplexType.LINE;

        c_cur = instantiate(this.a_n_simplexPhy);
        c_cur.parent = this.a_line_game.node;
      } // com_simplex = c_cur.getComponent(SimplexCollider)!;
      // com_simplex.vertices[0] = pos_cur[i - 1];
      // com_simplex.vertices[1] = pos_cur[i];
      // com_simplex.vertices[2] = v3(0, 0, 0);
      // com_simplex.vertices[3] = v3(0, 0, 0);
      // com_simplex.updateVertices();
      // com_simplex.enabled = false;
      // com_simplex.enabled = true;
      //中心点坐标


      var posAdd = v3();
      Vec3.add(posAdd, pos_cur[i - 1], pos_cur[i]);
      posAdd.multiplyScalar(0.5);
      c_cur.setPosition(posAdd);
      var posSub = v3();
      Vec3.subtract(posSub, pos_cur[i], pos_cur[i - 1]);
      var len = posSub.length();
      c_cur.scale = v3(len / 5, 1, 1); //旋转角度

      var radian = -v2(posSub.x, posSub.y).signAngle(v2(1, 0));
      var angle = misc.radiansToDegrees(radian);
      c_cur.angle = angle;

      if (angle != 0) {
        isAllZero = false;
      }
    }

    for (; i < children.length; i++) {
      children[i].destroy();
    }

    App.GameCtrl.isLineAngleZero = isAllZero;
  };

  _proto.updateLine_mesh = function updateLine_mesh() {
    if (!App.GameCtrl.isLineDirty) return;
    App.GameCtrl.isLineDirty = false;
    var pos_cur = App.GameCtrl.pos_game;
    if (pos_cur.length < 2) return;
    this.node.getComponent(RigidBody); //设置line points

    this.a_line_game.positions = pos_cur; //更新节点数据

    this.a_line_game.node.destroyAllChildren(); // let c_cur: Node = this.a_line_game.node.children[0];
    // if (!c_cur) {
    //     c_cur = instantiate(this.a_n_meshPhy);
    // }

    var c_cur = instantiate(this.a_n_meshPhy);
    c_cur.parent = this.a_line_game.node;
    c_cur.setPosition(v3(0, 0, 0));
    var posArr = [];

    for (var i = 0; i < pos_cur.length; i++) {
      posArr.push(pos_cur[i].x, pos_cur[i].y, -0.5);
      posArr.push(pos_cur[i].x, pos_cur[i].y, 0.5);
    }

    var indicesArr = [];
    var index_indices = 0;
    var baseIdx = 0;

    for (var _i = 0; _i < pos_cur.length; _i++) {
      baseIdx = _i * 2;
      indicesArr[index_indices++] = baseIdx;
      indicesArr[index_indices++] = baseIdx + 1;
      indicesArr[index_indices++] = baseIdx + 2;
      indicesArr[index_indices++] = baseIdx + 3;
      indicesArr[index_indices++] = baseIdx + 2;
      indicesArr[index_indices++] = baseIdx + 1;
    }

    var primitiveMode = gfx.PrimitiveMode.TRIANGLE_STRIP;
    var attributes = [{
      name: gfx.AttributeName.ATTR_POSITION,
      format: gfx.Format.RGB32F
    }];
    var meshCofig = {
      positions: posArr,
      indices: indicesArr,
      primitiveMode: primitiveMode,
      attributes: attributes
    };
    var mesh = utils.createMesh(meshCofig);
    var meshRender = c_cur.getComponent(MeshRenderer);
    meshRender.mesh = mesh;
    var m = new Material();
    m.copy(this.mat_new);
    meshRender.setMaterial(m, 0);
    c_cur.getComponent(MeshCollider).mesh = mesh;
  };

  _proto.updateWinTip = function updateWinTip() {
    if (!this.n_winTip.active) {
      var x_ball = App.GameCtrl.ball_game.worldPosition.x;
      var w_view = App.DataMgr.vSize_game.width;

      if (x_ball + w_view >= App.DataMgr.mapLen) {
        this.n_winTip.active = true;
        this.n_winTip.setWorldPosition(v3(App.DataMgr.mapLen, 0, 0));
      }

      return;
    }

    var x_offset = this.n_winTip.worldPosition.x - App.GameCtrl.ball_game.worldPosition.x;

    if (x_offset < App.DataMgr.vSize_game.width) {
      this.n_winTip.scale = v3(1, App.DataMgr.vSize_game.height * 1.7, 1);
      var v4 = new math.Vec4(1.0, App.DataMgr.vSize_game.height * 1.7, 0.0, 0.0);

      this._p_winTip.setUniform(this._h_winTip, v4);
    }
  };

  return GameScene;
}(Component), _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "a_line_game", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "a_n_ball", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "a_n_cubePhy", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "a_n_meshPhy", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "a_n_simplexPhy", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "a_n_map", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "n_winTip", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "n_testShow", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "ps_ballDie", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, "mat_new", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class2.prototype, "mat_line", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class2.prototype, "tex_tepm", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class2.prototype, "mat_ballPSDie", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
})), _class2)) || _class);
export { GameScene as default };

_cclegacy._RF.pop();